<template>
    <div class="reports" v-if="isTabs">
        <div v-if="reportsDispatch.length || itemsSafety.length || itemsBilling.length" class="component-holder">
            <div class="tabs-holder">
                <button
                v-for="tab in tabs"
                :key="tab"
                :class="['tab-button', { active: currentTab === tab }]"
                @click="setCurrentComp(tab)"
            >
                {{ tab }}
            </button>
            </div>
            <transition name="bounce">
                <keep-alive>
                    <component
                        v-if="toggleComponent"
                        class="tabReports"
                        :is="currentComp"
                        @edit-invoice="editInvoice"
                        @send-invoice="sendInvoice"
                        @paid-invoice="paidInvoice"
                        @updateLists="onUpdateList"
                        :list-items="reportsOldList"
                        :listItemsFilter="reportsOldFilter"
                        :listSafety="reportsSafetyList"
                        :listSafetyFilter="reportsSafetyFilter"
                        :listBilling="reportsBillingList"
                        :listBillingFilter="reportsBillingFilter"
                        :permissions="permissions"
                    ></component>
                </keep-alive>
            </transition>
        </div>
        <div v-else class="notText">You don't have any reports yet</div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
// async component
const ReportList = () => import('@/components/Statistics/ReportsOld/Reports-list/ReportList');
const ReportSafetyList = () => import('@/components/Statistics/ReportsOld/Reports-list/ReportSafetyList');
const ReportBillingList = () => import('@/components/Statistics/ReportsOld/Reports-list/ReportBillingList');
/*
getReportsSafetyFilter
getReportsBillingFilter
*/
export default {
	components: {
		ReportList,
		ReportSafetyList,
		ReportBillingList
	},
	data: () => ({
		currentComp: 'ReportList',
		currentTab: '',
		tabs: [],
		reportsDispatch: [],
		reportsSafety: [],
		reportsBilling: [],
		toggleComponent: true,
		invoiceId: "new",
		index: 0,
		isTabs: false
	}),
	computed: {
		...mapGetters([
			'reportsOldList',
			'reportsOldFilter',
			'reportsSafetyList',
			'reportsSafetyFilter',
			'reportsBillingList',
			'reportsBillingFilter',
			'permissions'
		]),
		itemsDispatch: {
			get() {
				return this.reportsDispatch;
			},
			set(data) {
				this.reportsDispatch = data;
			}
		},
		itemsSafety: {
			get() {
				return this.reportsSafety;
			},
			set(data) {
				this.reportsSafety = data;
			}
		},
		itemsBilling: {
			get() {
				return this.reportsBilling;
			},
			set(data) {
				this.reportsBilling = data;
			}
		}
	},
	methods: {
		...mapActions([ 'getReportsOldList', 'getReportsSafetyList', 'getReportsBillingList' ]),
		setCurrentComp(tab) {
			this.currentTab = tab;
			if (tab === 'Dispatch') {
				this.currentComp = 'ReportList';
				this.index = 0;
			}

			if (tab === 'Safety') {
				this.index = 1;
				this.currentComp = 'ReportSafetyList';
			}

			if (tab === 'Billing') {
				this.index = 2;
				this.currentComp = 'ReportBillingList';
			}
		},
		sendInvoice(item) {
			const index = this.reportsDispatch.indexOf(item);
			item.invoice_status = "Sent";
			this.reportsDispatch.splice(index, 1, item);
		},
		paidInvoice(item) {
			const index = this.reportsDispatch.indexOf(item);
			item.invoice_status = "Payed";
			this.reportsDispatch.splice(index, 1, item);
		},
		editInvoice(id) {
			this.invoiceId = id;
			this.toggleComponent = !this.toggleComponent;
		},
		updateList(data) {
			this.toggleComponent = !this.toggleComponent;
			this.reportsDispatch.unshift(data.invoice);
		},
		updateInvoice(data) {
			this.toggleComponent = !this.toggleComponent;
			this.reportsDispatch = this.reportsDispatch.map(obj => {
				if (obj.invoice_id === data.invoice.invoice_id) {
					return data.invoice;
				}

				return obj;
			});
		},
		async onUpdateList(mark) {
			if (mark === 1) {
				await this.getReportsOldList();
				this.reportsDispatch = this.reportsOldList;
			}

			if (mark === 2) {
				await this.getReportsSafetyList();
				this.itemsSafety = this.reportsSafetyList;
			}

			if (mark === 3) {
				await this.getReportsBillingList();
				this.itemsBilling = this.reportsBillingList;
			}
		},
		onGenerationTabs() {
			if (this.itemsDispatch.length) {
				this.tabs.push('Dispatch');
			}

			if (this.itemsSafety.length) {
				this.tabs.push('Safety');
			}

			if (this.itemsBilling.length) {
				this.tabs.push('Billing');
			}

			const key = this.tabs[0];

			this.currentTab = key;
			this.setCurrentComp(key);
		}
	},
	async created() {
		await this.getReportsOldList();
		await this.getReportsSafetyList();
		await this.getReportsBillingList();

		this.isTabs = true;

		this.itemsDispatch = this.reportsOldList;
		this.itemsSafety = this.reportsSafetyList;
		this.itemsBilling = this.reportsBillingList;

		this.onGenerationTabs();
	},
};
</script>
<style lang="scss" scoped>
    @import "./reportsOld";

</style>
